import { Fragment } from 'react';
import { v4 } from 'uuid';
import { LoadingAlert } from '@/components/Shared/LoadingAlert';
import { Separator } from '@/components/ui/separator';
import { TableDetailsItemSkeleton } from './TableDetailsItemSkeleton';
export function TableDetailsSkeleton({
  amount = 5
}: {
  amount: number;
}) {
  return <div className="p-5 bg-white">
      <LoadingAlert title="Fetching details" />

      {new Array(amount).fill(null).map(() => <Fragment key={v4()}>
          <TableDetailsItemSkeleton />
          <Separator />
        </Fragment>)}
    </div>;
}